"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowItemTransferValidationDTO_1 = require("../model/WindowItemTransferValidationDTO");

var WindowItemWarningFlag_1 = require("../model/WindowItemWarningFlag");

var WindowItemTransferValidationDTOConverter_1 = require("./WindowItemTransferValidationDTOConverter");
/**
 * Default implementation of WindowItemTransferValidationDTOConverter.
 *
 * @author Tomáš Leity
 */


var WindowItemTransferValidationDTOConverterImpl =
/*#__PURE__*/
function (_WindowItemTransferVa) {
  _inherits(WindowItemTransferValidationDTOConverterImpl, _WindowItemTransferVa);

  function WindowItemTransferValidationDTOConverterImpl() {
    _classCallCheck(this, WindowItemTransferValidationDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemTransferValidationDTOConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowItemTransferValidationDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowItemTransferValidationDTO_1.WindowItemTransferValidationDTO(WindowItemTransferValidationDTO_1.WindowItemTransferValidationDTO.schema.windowItemId.valueOf(conversions.toClassReferenceId(source.windowItemId)), WindowItemTransferValidationDTO_1.WindowItemTransferValidationDTO.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), conversions.asFlagSet(source.flags, WindowItemWarningFlag_1.WindowItemWarningFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        productId: conversions.toDocumentReferenceId(source.productId),
        flags: source.flags.serialize()
      });
      return result;
    }
  }]);

  return WindowItemTransferValidationDTOConverterImpl;
}(WindowItemTransferValidationDTOConverter_1.WindowItemTransferValidationDTOConverter);

exports.WindowItemTransferValidationDTOConverterImpl = WindowItemTransferValidationDTOConverterImpl;